import React from "react";
import { MANAGE_FEE_ROUTES, getPathWithParam } from "../../../utils";
import { useHistory } from "react-router";
const FeeRunInformationCard = ({ listdata, index }) => {
  const history = useHistory();

  return (
    <div style={{ display: "flex" }}>
      <div
        className="ml-2 fw-600 ft-16 feePlanName"
        style={{ backgroundColor: index % 2 == 0 ? "#F8F8F8" : "#FEFEFE" }}
      >
        <span
          style={{
            backgroundColor: index % 2 == 0 ? "#F8F8F8" : "#FEFEFE",
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={() =>
            history.push(
              getPathWithParam({
                path: MANAGE_FEE_ROUTES.FEE_RUN_PARTICIPANT_DETAILS,
                pathParam: [1],
              })
            )
          }
        >
          {listdata.Name}
        </span>
        <p className="fw-500 ft-14" style={{ color: "#7C7C80" }}>
          Plan ID : 122345
        </p>
      </div>

      <div
        className="fw-600 ft-16 feePlanBalance"
        style={{ backgroundColor: index % 2 == 0 ? "#F8F8F8" : "#FEFEFE" }}
      >
        {listdata.PlanBalance}
        <p className="fw-500 ft-14" style={{ color: "#7C7C80" }}>
          (As on 06/30/2023)
        </p>
      </div>

      <div
        className="fw-600 ft-16 feePlanBalance"
        style={{ backgroundColor: index % 2 == 0 ? "#F8F8F8" : "#FEFEFE" }}
      >
        {listdata.FeeCollected}
      </div>

      <div
        className="fw-600 ft-16 feePlanBalance"
        style={{ backgroundColor: index % 2 == 0 ? "#F8F8F8" : "#FEFEFE" }}
      >
        {listdata.Date}
      </div>
    </div>
  );
};

export default FeeRunInformationCard;
